// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jvvM","content":"styles_content__1DEmu","row":"styles_row__3eaKP","footer":"styles_footer__1E38v","phraseLength":"styles_phraseLength__3wpaU"};